/**
 * Magnific Popup Lazy Loader
 * Lädt magnific-pop-up.js nur wenn Popup-Trigger auf der Seite vorhanden sind
 * Einsparung: 42KB auf Seiten ohne Popups
 */

window.PopupLazyLoader = {

  /**
   * Prüft ob Popup-Trigger auf der Seite vorhanden sind
   * @returns {boolean} True wenn Popup-Trigger gefunden
   */
  hasPopupTriggers: function () {
    // Suche nach verschiedenen Popup-Trigger-Elementen




    const popupSelectors = [
      '.open-pop-up',
      '[data-effect*="mfp-"]',
      '.size-chart',
      '[href*="#fit-pop-up"]',
      '[href*="#shipping-pop-up"]',
      '.mfp-hide',
      '.white-popup'
    ];

    for (let selector of popupSelectors) {
      if (document.querySelector(selector)) {
        return true;
      }
    }

    return false;
  },

  /**
   * Lädt Magnific Popup dynamisch
   */
  loadMagnificPopup: function () {
    return new Promise((resolve, reject) => {
      // Prüfe ob bereits geladen
      if (window.jQuery && window.jQuery.fn.magnificPopup) {
        resolve();
        return;
      }

      // Erstelle Script-Tag mit korrektem Asset-Pfad
      const script = document.createElement('script');

      // Verwende korrekte Shopify Asset URL
      script.src = window.MAGNIFIC_POPUP_URL ||
        (window.Shopify?.routes?.root ?
          window.Shopify.routes.root + 'assets/magnific-pop-up.js' :
          '/assets/magnific-pop-up.js');
      script.async = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        console.error('❌ Failed to load Magnific Popup');
        reject(new Error('Failed to load Magnific Popup'));
      };

      document.head.appendChild(script);
    });
  },

  /**
   * Initialisiert Popups nach dem Laden
   */
  initializePopups: function () {
    // Warte kurz bis jQuery und Magnific Popup verfügbar sind
    setTimeout(() => {
      if (window.jQuery && window.jQuery.fn.magnificPopup) {
        // Standard Size Guide Popups
        jQuery('.open-pop-up').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#username',
          modal: true,
          removalDelay: 300,
          mainClass: 'mfp-zoom-out',
           callbacks: {
             beforeOpen: function () {
               // Setze Animation-Klasse basierend auf data-effect Attribut
               var effect = this.st.el.attr('data-effect');
               if (effect) {
                 this.st.mainClass = effect;
               } else {
                 this.st.mainClass = 'mfp-zoom-out';
               }

               // Füge mfp-with-anim Klasse zum Content hinzu
               setTimeout(() => {
                 jQuery('.mfp-content').addClass('mfp-with-anim');
               }, 10);
             },
             // Removed Slick, now static vertical gallery
           }
        });

        // Spezielle Popup-Konfigurationen
        jQuery('[data-effect="mfp-zoom-out"]').magnificPopup({
          type: 'inline',
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: 'auto',
          closeBtnInside: true,
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: 'mfp-zoom-out',
          callbacks: {
            beforeOpen: function () {
              // Füge mfp-with-anim Klasse zum Content hinzu
              setTimeout(() => {
                jQuery('.mfp-content').addClass('mfp-with-anim');
              }, 10);
            }
          }
        });
      }
    }, 100);
  },

  /**
   * Event-Handler für dynamisch hinzugefügte Popup-Trigger
   */
  handleDynamicTriggers: function () {
    // Event-Delegation für dynamisch hinzugefügte Elemente
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.open-pop-up, [data-effect*="mfp-"]');

      if (trigger && !window.jQuery?.fn?.magnificPopup) {
        e.preventDefault();

        this.loadMagnificPopup()
          .then(() => {
            this.initializePopups();
            // Trigger das ursprüngliche Event nach kurzer Verzögerung
            setTimeout(() => {
              trigger.click();
            }, 200);
          })
          .catch(error => {
            console.error('Popup loading failed:', error);
          });
      }
    });
  },

  /**
   * Hauptfunktion - Prüft und lädt Popups bei Bedarf
   */
  init: function () {
    // Prüfe sofort nach DOM-Load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.checkAndLoad();
      });
    } else {
      this.checkAndLoad();
    }

    // Handle dynamische Trigger immer
    this.handleDynamicTriggers();

    // Prüfe auch nach dynamischen Inhalten
    this.observeChanges();
  },

  /**
   * Prüft und lädt Popups
   */
  checkAndLoad: function () {
    if (this.hasPopupTriggers()) {
      this.loadMagnificPopup()
        .then(() => {
          this.initializePopups();
        })
        .catch(error => {
          console.error('Popup loading failed:', error);
        });
    }
  },

  /**
   * Beobachtet DOM-Änderungen für dynamisch geladene Popup-Trigger
   */
  observeChanges: function () {
    if (!window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      let hasNewTriggers = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Prüfe ob neue Popup-Trigger hinzugefügt wurden
              const triggerSelectors = ['.open-pop-up', '[data-effect*="mfp-"]', '.size-chart'];
              for (let selector of triggerSelectors) {
                if (node.matches && node.matches(selector) || node.querySelector && node.querySelector(selector)) {
                  hasNewTriggers = true;
                  break;
                }
              }
            }
          });
        }
      });

      if (hasNewTriggers && !window.jQuery?.fn?.magnificPopup) {
        this.checkAndLoad();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

// Auto-Initialize
PopupLazyLoader.init();
